<template>
  <div class="content area">
    <div class="partCard cardTop">
      <div :class="'industryAdd'+tag"></div>
      <div class="centerMap">
        <div class="totalSurver">
          <p style="color:rgba(255,255,255,1);fontSize:16px">
            区县名:
            <span style="color:#C7FF06;fontSize:24px">{{investMapment.label}}</span>
          </p>
          <p style="color:rgba(255,255,255,1);fontSize:16px">
            工业增加值增速:
            <span style="color:#C7FF06;fontSize:24px">{{investMapment.value.toFixed(1)}}%</span>
          </p>
        </div>
        <div
          :id="'inverstMapAdd'+tag"
          style="width:620px;height:420px;position:relative;top:-105px;"
        ></div>
      </div>

      <div class="rightInverstCard">
        <div class="background-img indicatorsCard">
          <div class="inverstTitle">先行指标</div>
          <div class="indicatorsCell">
            <p>
              各项存款余额：
              <span>{{indicatorData.depositBalance}}亿元</span>
            </p>
            <p>
              各项贷款余额：
              <span>{{indicatorData.loanBalance}}亿元</span>
            </p>
            <p>
              工业用电量累计增速：
              <span>{{indicatorData.industrialPower}}%</span>
            </p>
          </div>
          <div class="indicatorsCell">
            <p>
              工业增加值：
              <span>{{indicatorData.addedTax}}%</span>
            </p>
            <p>
              PMI当月指数：
              <span>{{indicatorData.pmi}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="partCard">
      <div :class="'industryInvest'+tag"></div>
      <div class="citySurvey">
        <div class="title">
          全市统计
          <div class="tabChoose">
            <span @click="changeCharts('part_1')" :class="{'current':currentPart=='part_1'}">利润总额增速</span>
            <span @click="changeCharts('part_2')" :class="{'current':currentPart=='part_2'}">营业收入增速</span>
          </div>
        </div>
        <div class="contentBox">
          <div :id="'part_1'+tag" v-show="currentPart=='part_1'"></div>
          <div :id="'part_2'+tag" v-show="currentPart=='part_2'"></div>
        </div>
      </div>
      <div class="mainProject">
        <div class="inverstTitle">主要工业产品</div>
        <div class="mainContent">
          <table class="mainTable">
            <tr>
              <td colspan="3">工业主要产品产量</td>
            </tr>
            <tr>
              <td width="300px">规模以上工业主要产品产量</td>
              <!-- <td>9月</td>
              <td>当月增长（%）</td>-->
              <td>1-9月</td>
              <td>累计增长（%）</td>
            </tr>

            <tr v-for="(item,index) in mainPro" :key="index">
              <td>{{item.name}}</td>
              <td>{{item.midValue}}</td>
              <td>{{item.rightValue}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MapJson } from "@/assets/mapJson.js";
import {
  industryAddOptionSin,
  industryInverstOptionSin,
  totalCountSin,
  inCountSin
} from "@/utils/echarts_set.js";
export default {
  props: ["tag"],
  data() {
    return {
      currentPart: "part_2",
      // 区域检测 地图标识
      investMapment: {
        name: "",
        value: 0
      },
      //区域数据
      investlocAddValue: [
        { name: "洛宁县", value: "0" },
        { name: "汝阳县", value: "0" },
        { name: "孟津县", value: "0" },
        { name: "嵩县", value: "0" },
        { name: "吉利区", value: "0" },
        { name: "洛龙区", value: "0" },
        { name: "新安县", value: "0" },
        { name: "栾川县", value: "0" },
        { name: "宜阳县", value: "0" },
        { name: "伊川县", value: "0" },
        { name: "偃师市", value: "0" },
        { name: "老城区", value: "0" },
        { name: "涧西区", value: "0" },
        { name: "西工区", value: "0" },
        { name: "瀍河回族区", value: "0" }
      ],
      //打点的坐标信息
      geoCoordMap: {
        老城区: [112.477298, 34.682945],
        涧西区: [112.399243, 34.654251],
        西工区: [112.443232, 34.667847],
        瀍河回族区: [112.491625, 34.684738],
        吉利区: [112.584796, 34.899093],
        洛龙区: [112.456634, 34.618557],
        新安县: [112.141403, 34.728679],
        孟津县: [112.443892, 34.826485],
        嵩县: [112.087765, 34.131563],
        栾川县: [111.618386, 33.783195],
        汝阳县: [112.473789, 34.15323],
        宜阳县: [112.179989, 34.516478],
        洛宁县: [111.655399, 34.387179],
        伊川县: [112.429384, 34.423416],
        偃师市: [112.787739, 34.723042]
      },
      //先行指标数据
      indicatorData: {
        depositBalance: "-",
        loanBalance: "-",
        industrialPower: "-",
        addedTax: "-",
        pmi: "-"
      },
      //主要工业产品数据
      mainPro: [],
      //echarts图表数据
      echartsData: {
        yaxisIndustryInvestment: [], //全市工业投资
        yaxisAllCityStatisticProfit: [], //全市统计  利润总额累计增速
        yaxisAllCityStatisticIncome: [], //全市统计  营业收入累计增速
        xaxisInvestment: [], //工业投资月份
        yaxisAddedValue: [], //全市工业增加值增速
        xaxis: [] //全市工业增加自增速和全市统计的月份
      },
      DataMax: 0,
      DataMin: 0
    };
  },
  methods: {
    changeCharts(part) {
      this.currentPart = part;
    },
    //处理数据
    convertData(geoCoordMap, data) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
        var geoCoord = geoCoordMap[data[i].label];
        if (geoCoord) {
          res.push({
            name: data[i].label,
            value: geoCoord.concat(data[i].value * 1.5)
          });
        }
      }
      // for (let j = 0; j < res.length; j++) {
      //   res[j].value[2] = res[j].value[2];
      // }
      return res;
    },
    // 区域地图
    getInverstMapAdd() {
      // inverstMapAdd
      let _this = this;
      function getMap(data) {
        _this.$echarts.registerMap("luoyang", data);
        var inverstAreaChart = _this.$echarts.init(
          document.getElementById("inverstMapAdd")
        );
        _this.setInverstAddOption(inverstAreaChart);
      }
      getMap(MapJson);
    },
    //区域地图配置
    setInverstAddOption(inverstChart) {
      let _this = this;

      var inverstMapOption = {
        color: ["#D01864", "#F2F832", "#25CEF3"],
        backgroundColor: "rgba(255,255,255,0)", //背景色
        title: {
          text: "", //标题内容
          x: "center", //标题位置
          textStyle: {
            color: "#fff" //标题颜色
          }
        },
        grid: {
          right: 100,
          top: "center"
        },
        tooltip: {
          //提示信息
          trigger: "item",
          formatter: function(params) {
            let CurTime = new Date();
            let current = `${CurTime.getFullYear()}年${
              CurTime.getMonth() + 1 > 9 ? "" : 0
            }${CurTime.getMonth() + 1}月`;
            if (typeof params.value[1] == "undefined") {
              return (
                "时间：" +
                current +
                "<br/>" +
                "区域名：" +
                params.name +
                " <br/> " +
                "工业增加值增速：" +
                params.value.toFixed(1) +
                "%"
              );
            } else {
              return "";
            }
          },
          extraCssText: "background:#0ADAFF;padding:20px 10px", //编辑tooltip的css样式
          textStyle: {
            fontSize: 22
          }
        },
        visualMap: {
          //左下角数据颜色映射
          show: true,
          max: _this.DataMax,
          min: _this.DataMin,
          left: 40,
          bottom: 50,
          itemWidth: 10,
          itemHeight: 100,
          calculable: true,
          inRange: {
            color: ["#25CEF3", "#F2F832", "#D01864"]
          },
          textStyle: {
            color: "rgba(255,255,255)"
          }
        },
        geo: {
          //地图配置
          map: "luoyang",
          roam: false, //开启缩放scale 和拖动move  true 同时开启
          aspectScale: 1, //地图长宽比
          selectedMode: "single", //鼠标点击选中
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              areaColor: "#2B91B7",
              borderColor: "#111",
              shadowBlur: 1,
              shadowColor: "#5F6476",
              shadowOffsetX: 2,
              shadowOffsetY: 2
            },
            emphasis: {
              areaColor: "#2B91B7",
              shadowBlur: 1,
              shadowColor: "#5F6476",
              shadowOffsetX: 5,
              shadowOffsetY: 5
            }
          }
        },
        series: [
          {
            name: "红色代表增涨最多",
            type: "effectScatter", //涟漪特效散点图
            showEffectOn: "render", //涟漪特效展示时机
            rippleEffect: {
              //涟漪特效配置
              scale: 15, //涟漪扩散倍数
              period: 10 //涟漪动画周期
              // brushType: 'stroke'
            },
            hoverAnimation: true,
            coordinateSystem: "geo",
            data: _this //暂时自定义处理数据
              .convertData(_this.geoCoordMap, _this.investlocAddValue),
            symbolSize: function(val) {
              //图标大小
              return 0;
            },
            label: {
              normal: {
                formatter: "{b}",
                position: "right",
                show: true,
                color: "#fff"
              },
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              emphasis: {
                borderColor: "#fff",
                borderWidth: 1
              }
            },
            zlevel: 1
          },
          {
            type: "map",
            map: "luoyang",
            geoIndex: 0,
            aspectScale: 1, //长宽比
            showLegendSymbol: false, // 存在legend时显示
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false,
                textStyle: {
                  color: "#fff"
                }
              }
            },
            roam: false,
            animation: false,
            data: _this.investlocAddValue.map(res => {
              res = { name: res.label, value: res.value };
              return res;
            }),
            itemStyle: {
              normal: {
                areaColor: "#031525",
                borderColor: "#FFFFFF"
              },
              emphasis: {
                areaColor: "#2B91B7"
              }
            }
          }
        ]
      };
      inverstChart.setOption(inverstMapOption);
      this.autohover(inverstChart, 15);
    },
    // 区域卡片播放
    areaPic() {
      let _this = this;
      var areaShowBoxTimer = null;
      areaShowBoxTimer && clearInterval(areaShowBoxTimer);
      var i = 0;
      areaShowBoxTimer = setInterval(function() {
        _this.investMapment = _this.investlocAddValue[i];
        i++;
        if (i > _this.investlocAddValue.length - 1) i = 1;
      }, 3000);
    },
    //加载表格echarts配置
    setEchartsOption() {
      let _this = this;
      //工业增加
      var industryAddL = _this.$echarts.init(
        document.querySelector(".industryAdd")
      );
      industryAddL.setOption(industryAddOptionSin(this.echartsData));
      this.normalTable(industryAddL, this.echartsData.xaxis.length - 1);
      //全市统计
      var part_1left = _this.$echarts.init(document.querySelector("#part_1"));
      var part_2left = _this.$echarts.init(document.querySelector("#part_2"));
      part_1left.setOption(totalCountSin(this.echartsData));
      this.normalTable(part_1left, this.echartsData.xaxis.length - 1);
      part_2left.setOption(inCountSin(this.echartsData));
      this.normalTable(part_2left, this.echartsData.xaxis.length - 1);
      //工业投资
      var industryInvestL = _this.$echarts.init(
        document.querySelector(".industryInvest")
      );
      industryInvestL.setOption(industryInverstOptionSin(this.echartsData));
      this.normalTable(
        industryInvestL,
        this.echartsData.xaxisInvestment.length - 1
      );
    },
    // 普通图表自动播放
    normalTable(echart, num) {
      var index = 0; //播放所在下标
      var mTimearea = null;
      mTimearea && clearInterval(mTimearea);
      mTimearea = setInterval(function() {
        echart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: index
        });
        index++;
        if (index > num) {
          index = 0;
        }
      }, 3000);
    },
    //轮播切换tooltips
    autohover(inverstChart, num) {
      var count = 0;
      var timeTicketarea = null;
      timeTicketarea && clearInterval(timeTicketarea);
      timeTicketarea = setInterval(function() {
        inverstChart.dispatchAction({
          type: "downplay",
          seriesIndex: 1
        });
        inverstChart.dispatchAction({
          type: "highlight",
          seriesIndex: 1,
          dataIndex: count
        });
        inverstChart.dispatchAction({
          type: "showTip",
          seriesIndex: 1,
          dataIndex: count
        });
        if (count >= num) {
          count = 0;
        }
        count++;
      }, 1000 * 3);
      // inverstChart.on("mouseover", function(params) {
      //   clearInterval(timeTicket);
      //   inverstChart.dispatchAction({
      //     type: "downplay",
      //     seriesIndex: 0
      //   });
      //   inverstChart.dispatchAction({
      //     type: "highlight",
      //     seriesIndex: 0,
      //     dataIndex: params.dataIndex
      //   });
      //   inverstChart.dispatchAction({
      //     type: "showTip",
      //     seriesIndex: 0,
      //     dataIndex: params.dataIndex
      //   });
      // });
      // inverstChart.on("mouseout", function() {
      //   timeTicket && clearInterval(timeTicket);
      //   timeTicket = setInterval(function() {
      //     inverstChart.dispatchAction({
      //       type: "downplay",
      //       seriesIndex: 0
      //     });
      //     inverstChart.dispatchAction({
      //       type: "highlight",
      //       seriesIndex: 0,
      //       dataIndex: count
      //     });
      //     inverstChart.dispatchAction({
      //       type: "showTip",
      //       seriesIndex: 0,
      //       dataIndex: count
      //     });
      //     if (count >= num) {
      //       count = 0;
      //     }
      //     count++;
      //   }, 1000 * 3);
      // });
    },
    //获取·数据
    getData() {
      this.$axios.get("/business/areaMonitoring/antecedentIndex").then(res => {
        this.indicatorData = res.data;
      });
      this.$axios
        .get("/business/areaMonitoring/industryProductsArea")
        .then(res => {
          this.mainPro = res.data;
        });
      this.$axios
        .get("/business/areaMonitoring/statistics/利润总额累计增速")
        .then(res => {
          this.echartsData.yaxisAllCityStatisticProfit =
            res.data.yaxisAllCityStatistic;
          this.echartsData.yaxisIndustryInvestment =
            res.data.yaxisIndustryInvestment;
          this.echartsData.xaxisInvestment = res.data.xaxisInvestment.map(
            res => res + "月"
          );
          this.echartsData.yaxisAddedValue = res.data.yaxisAddedValue;
          this.echartsData.xaxis = res.data.xaxis.map(res => res + "月");
          this.setEchartsOption();
        });
      this.$axios
        .get("/business/areaMonitoring/statistics/营业收入累计增速")
        .then(res => {
          this.echartsData.yaxisAllCityStatisticIncome =
            res.data.yaxisAllCityStatistic;
          this.echartsData.yaxisIndustryInvestment =
            res.data.yaxisIndustryInvestment;
          this.echartsData.xaxisInvestment = res.data.xaxisInvestment.map(
            res => res + "月"
          );
          this.echartsData.yaxisAddedValue = res.data.yaxisAddedValue;
          this.echartsData.xaxis = res.data.xaxis.map(res => res + "月");
          this.setEchartsOption();
        });

      this.$axios
        .get("/business//areaMonitoring/industrialAddedValueSpeedUp")
        .then(res => {
          // console.log("大屏地图数据", res.data);

          let result = res.data.filter(
            obj => !["洛阳市", "高新区", "伊滨区", "洛阳"].includes(obj.label)
          );

          this.investlocAddValue = result.map(res => {
            res.value = Number(res.value);
            return res;
          });
          this.investMapment = this.investlocAddValue[0];
          this.DataMax = this.investlocAddValue[0].value;
          this.DataMin = this.investlocAddValue[0].value;
          for (var i = 0; i < this.investlocAddValue.length - 1; i++) {
            this.DataMax =
              this.DataMax < this.investlocAddValue[i + 1].value
                ? this.investlocAddValue[i + 1].value
                : this.DataMax;
            this.DataMin =
              this.DataMin > this.investlocAddValue[i + 1].value
                ? this.investlocAddValue[i + 1].value
                : this.DataMin;
          }

          this.getInverstMapAdd();
          this.areaPic();
        });
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style lang="less" scoped>
.area {
  flex-direction: column;
  .partCard {
    height: 320px;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
  }
  .partCard.cardTop {
    height: 400px;
    bottom: 36px;
  }
  .industryAdd {
    width: 500px;
    height: 400px;
    background: url(../../../assets/imgs/background/area_right_bg.png) no-repeat;
    background-size: 500px 100%;
  }

  /*增速地图*/
  .centerMap {
    height: 440px;
    width: 640px;
    .totalSurver {
      box-sizing: border-box;
      position: relative;
      z-index: 1000;
      top: 7px;
      left: 7px;
      width: 245px;
      height: 115px;
      padding: 28px 0 0 16px;
      background: url(../../../assets/imgs/background/inverst_map_bg.png) center
        no-repeat;
      background-size: 245px 115px;
      p {
        margin: 3px 0;
      }
    }
  }
  /*增速右侧区域*/
  .rightInverstCard {
    width: 500px;
    height: 420px;
    bottom: 35px;
    .indicatorsCard {
      width: 500px;
      height: 175px;
      background-size: 500px 175px;
      margin-bottom: 17px;
      .indicatorsCell {
        float: left;
        text-align: left;
        padding-left: 20px;
        flex-direction: column;
        width: 50%;
        box-sizing: border-box;
        color: #fff;
        p {
          margin: 7px 0;
          span {
            font-size: 16px;
            color: #338899;
          }
        }
      }
    }
    .rankingCard {
      width: 730px;
      height: 335px;
      background-size: 730px 335px;
      .rankingContent {
        display: flex;
        .rankingTab {
          width: 150px;
          height: 220px;
          margin-left: 30px;
          color: #fff;
          padding: 10px;
          background: rgba(109, 180, 253, 0.4);
          .rankingBar {
            width: auto;
            margin-top: 15px;
            padding: 10px 15px;
            cursor: pointer;
          }
          .rankingBar.current {
            border-radius: 45px;
            background: #00d9ff;
          }
        }
        .rankingChart {
          height: 240px;
          width: 500px;
          background: rgba(109, 180, 253, 0.2);
          div {
            height: 240px;
            width: 500px;
          }
        }
      }
    }
  }
  /*主要工业产品*/
  .mainProject {
    width: 500px;
    height: 520px;
    margin-top: -200px;
    background: url(../../../assets/imgs/background/area_left_bg.png) center
      no-repeat;
    background-size: 500px 100%;
    .mainContent {
      box-sizing: border-box;
      padding: 0px 20px;
      font-size: 14px;
      .mainTable {
        width: 100%;
        text-align: center;
        border-collapse: collapse;
        tr {
          height: 18px;
        }
        td {
          padding: 4px;
          border: 1px solid rgba(222, 222, 253, 0.5);
          color: #fff;
          background: rgba(109, 180, 253, 0.2);
        }
      }
    }
  }
  .citySurvey {
    position: relative;
    width: 830px;
    justify-content: space-between;
    background: url(../../../assets/imgs/background/area_right_bg.png) center
      no-repeat;
    background-size: 830px 100%;
    .title {
      display: flex;
      justify-content: space-between;
      font-size: 18px;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      padding: 20px 28px;
      align-items: flex-end;
    }
    .tabChoose {
      font-size: 14px;
      font-weight: 500;
      color: #a9ddee;
      span {
        margin-right: 14px;
        cursor: pointer;
      }
      span.current {
        color: #00d8ff;
      }
    }
    .contentBox {
      display: flex;
      color: #fff;
      flex-wrap: wrap;
      justify-content: space-between;
      #part_1 {
        width: 730px;
        height: 245px;
        margin: 14px auto 0;
      }
      #part_2 {
        width: 730px;
        height: 245px;
        margin: 14px auto 0;
      }
    }
  }
  .industryInvest {
    margin-top: 10px;
    height: 310px;
    width: 500px;
    background: url(../../../assets/imgs/background/area_right_bg.png) center
      no-repeat;
    background-size: 500px 310px;
  }
}
.background-img {
  background: url(../../../assets/imgs/background/area_right_bg.png) center
    no-repeat;
}

.inverstTitle {
  display: flex;
  justify-content: space-between;
  font-size: 26px;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  padding: 20px 40px;
  align-items: flex-end;
}
</style>